module.exports = __webpack_public_path__ + "img/one.048691a3.png";